import React, { forwardRef } from 'react';
import { Control, Controller, FieldValues, Path } from 'react-hook-form';
import * as S from './styles';

type RadioButtonProps<TFieldValues extends FieldValues> = {
    name: Path<TFieldValues>;
    control: Control<TFieldValues>;
    label: string;
    value: string;
};

type RadioButtonComponent = {
    <TFieldValues extends FieldValues>(
        props: RadioButtonProps<TFieldValues> & React.RefAttributes<HTMLInputElement>
    ): React.ReactElement;
    displayName?: string;
};

const RadioButton = forwardRef(function RadioButtonInner<TFieldValues extends FieldValues>(
    { name, control, label, value }: RadioButtonProps<TFieldValues>,
    ref: React.ForwardedRef<HTMLInputElement>
) {
    return (
        <Controller
            name={name}
            control={control}
            render={({ field: { onChange, onBlur, value: selectedValue } }) => (
                <S.Container>
                    <S.InputColumn>
                        <label>
                            <input
                                type="radio"
                                value={value}
                                checked={selectedValue === value}
                                onChange={onChange}
                                onBlur={onBlur}
                                ref={ref} // Agora podemos usar ref aqui
                            />
                            {label}
                        </label>
                    </S.InputColumn>
                </S.Container>
            )}
        />
    );
}) as unknown as RadioButtonComponent;

RadioButton.displayName = 'RadioButton';

export { RadioButton };
